module.exports = "/images/link-url.svg?6af56728888d9074aaf4d8261a3eceda";